<template>
    <ValidationObserver ref="form" v-slot="{ invalid }">
        <div class="absolute top-0 left-0 right-0 bottom-0 w-full overflow-hidden flex items-center text-center justify-center z-50" v-show="loading"><spinner line-fg-color="#F02629" size="55" :line-size="5"></spinner></div>
        <form id="form" v-if="!loading" @submit.prevent="submitForm" class="flex flex-col h-full">
            <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
                <template slot="title">{{ type }} Option</template>
            </page-header>

            <tabs :tabs="tabs" :active="startTab" @setTab="setActiveTab" ref="tabs"></tabs>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" role="alert" v-show="invalid && submitted" >Please complete all required fields</div>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" v-if="errorMessage">{{ errorMessage }}</div>

            <div class="flex md:flex-row sm:flex-col flex-grow">
                <div class="md:w-3/4 sm:w-full px-4 sm:px-6 lg:px-6 bg-gray-200 border-r border-gray-400" v-show="activeTab === 'details'">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-select class="sm:col-span-6"
                                label="Group"
                                placeholder="Group"
                                name="group"
                                v-model="item.group"
                                :initialValue="initialValue.group"
                                return="value"
                                rules="required"
                                :required="true"
                                :options="options.groups"
                                :disabled="item.locked"
                                :readonly="item.locked"/>
                            <input-text class="sm:col-span-6"
                                label="Option"
                                placeholder="Option"
                                name="name"
                                v-model="item.name"
                                rules="required"
                                :required="true"
                                :disabled="item.locked"
                                :readonly="item.locked"/>
                            <input-text class="sm:col-span-4"
                                label="Abbreviation"
                                placeholder="Abbreviation"
                                name="abbreviation"
                                v-model="item.abbreviation"
                                :required="false" />
                            <input-text class="sm:col-span-4"
                                label="Value"
                                placeholder="Value"
                                name="value"
                                v-model="item.value"
                                :required="false" />
                            <input-text class="sm:col-span-4"
                                label="Container"
                                placeholder="Container"
                                name="container"
                                v-model="item.container"
                                :required="false" />
                            <input-textarea class="sm:col-span-12"
                                label="Description"
                                placeholder="Description"
                                name="description"
                                v-model="item.description"
                                :required="false" />
                        </div>
                    </ValidationObserver>
                </div>
                <div class="md:w-3/4 sm:w-full px-4 sm:px-6 lg:px-6 bg-gray-200 border-r border-gray-400" v-show="activeTab === 'meta'">
                    <json-editor @update="updateJSON"
                        :json="item.meta"
                        field="meta"
                        class="mt-6" />
                </div>
                <div class="md:w-1/4 sm:w-full px-4 sm:px-6 lg:px-6">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-toggle class="sm:col-span-6"
                                label="Active"
                                name="active"
                                v-model="item.active"
                                :required="false" />
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </form>
        <transition name="fade">
            <delete-confirmation-modal v-if="showDeleteModal" @close="closeDeleteModal" @delete="deleteItem" ref="datatableDeleteModal">
                <template slot="content">Are you sure you want to delete the <strong>{{ item.name }}</strong> Type?</template>
            </delete-confirmation-modal>
        </transition>
    </ValidationObserver>
</template>

<script>
    import axios from "axios";
    import FormSetup from "../../../mixins/Tabs";
    import FormButtons from "../../../mixins/FormButtons";
    import DeleteModal from "../../../mixins/DeleteModal";
    import JsonEditor from '../../../components/forms/JsonEditor';

    export default {
        name: "TypeForm",
        props: {
            id: {required: false},
            type: {required: true},
            return: {required: false, default: '/configuration/types'},
            page: {required: false, default: 'types'}
        },
        components: {
            JsonEditor
        },
        mixins: [
            FormSetup,
            FormButtons,
            DeleteModal
        ],
        data: function () {
            return {
                resource: 'types',
                pageActions: {
                    buttons: [
                        {
                            label: 'Save',
                            icon: 'save',
                            iconClass: 'text-green-600',
                            type: 'method',
                            method: 'save',
                        },
                        {
                            label: 'Cancel',
                            icon: 'times',
                            iconClass: 'text-red-600',
                            type: 'method',
                            method: 'cancel',
                        }
                    ],
                    additional: []
                },
                tabs: [
                    {
                        name: 'Details',
                        slug: 'details'
                    },
                    {
                        name: 'Meta',
                        slug: 'meta'
                    }
                ],
                startTab: null,
                loading: true,
                submitted: false,
                errorMessage: '',
                item: {},
                options: {
                    groups: []
                },
                jsonHolders: {
                    meta: {}
                }
            }
        },
        methods: {
            getData: function () {
                this.$Progress.start();

                axios.get(process.env.VUE_APP_API_URL + '/types/' + this.id).then(response => {
                    this.item = response.data;

                    this.$Progress.finish();
                    this.loading = false;
                })
                .catch(() => {
                    this.$Progress.finish();
                    this.loading = false;
                });
            },
            submitForm: function () {
                this.submitted = false;

                this.$refs.form.validate().then(success => {
                    let _method;
                    let _url;
                    if (!success) {
                        this.submitted = true;
                        return;
                    }

                    this.submitted = true;

                    this.$store.commit('TOGGLE_BACKDROP', {open: true});
                    this.errorMessage = '';

                    if (this.id) {
                        _url = process.env.VUE_APP_API_URL + '/types/' + this.id;
                        _method = 'PUT';
                    } else if (this.item.id) {
                        _url = process.env.VUE_APP_API_URL + '/types/' + this.item.id;
                        _method = 'PUT';
                    } else {
                        _url = process.env.VUE_APP_API_URL + '/types';
                        _method = 'POST';
                    }

                    if (!this.item.ordering || this.item.ordering === ''){
                        this.item.ordering = 0;
                    }

                    this.item.meta = this.jsonHolders.meta;

                    axios({
                        method: _method,
                        url: _url,
                        data: this.item
                    }).then(response => {

                        if (response.data.success) {
                            this.$store.dispatch('CLEAR_DATA').then(() => {
                                this.$store.commit('TOGGLE_BACKDROP', {open: false});

                                if (this.saveClose) {
                                    if (this.return) {
                                        this.$router.push(this.return);
                                    } else {
                                        this.$router.push('/configuration/types');
                                    }
                                } else {
                                    this.$router.push('/configuration/types');
                                }

                                this.$notify({
                                    group: 'main',
                                    type: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    duration: 5000
                                });
                            });
                        } else {
                            if (response.data.message) {
                                this.errorMessage = response.data.message;
                            }
                            this.$store.commit('TOGGLE_BACKDROP', {open: false});
                        }
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.errorMessage = error.response.data.message;
                        } else {
                            this.errorMessage = 'An error occurred. Please contact the System Administrator.';
                        }

                        this.$store.commit('TOGGLE_BACKDROP', {open: false});
                    });
                });
            },
            cancel: function () {
                this.$router.push(this.return);
            },
            methodHandler: function (method) {
                this[method]();
            },
            actionHandler: function (data) {
                this[data.method](data);
            },
            updateJSON(payload) {
                this.jsonHolders[payload.field] = JSON.parse(payload.json);
            }
        },
        beforeMount() {
            if (this.$store.getters.typeGroups.length === 0){
                this.$store.dispatch('GET_TYPE_GROUPS').then(() => {
                    this.options.groups = this.$store.getters.typeGroups.map(function (group) {
                        return { label: group.group_name, value: group.group };
                    });
                });
            } else {
                this.options.groups = this.$store.getters.typeGroups.map(function (group) {
                    return { label: group.group_name, value: group.group };
                });
            }
        },
        mounted() {
            if (this.type === "New") {
                this.loading = false;
                this.item.active = true;
                this.item.meta = {};
                this.$Progress.finish();
                // Se defaults here
            } else if (this.type === "Edit") {
                this.pageActions.additional.push({
                    label: 'Delete',
                    icon: 'trash-alt',
                    type: 'method',
                    method: 'deleteModal',
                    iconClass: 'text-red-500',
                    display: !!(this.$store.getters.permissions.indexOf('types.destroy') !== -1 || this.$store.getters.nimdarepus)
                });
                this.getData();
            }

            const params = new URLSearchParams(window.location.search)

            let windowLocationHash = window.location.hash.replace('#', '');

            if (windowLocationHash) {
                this.startTab = windowLocationHash;
            }
        },
        computed: {
            initialValue: function(){
                let output = {};

                if (this.item.group){
                    output['group'] = this.item.group;
                } else {
                    output['group'] =  null
                }

                return output;
            }
        }
    }
</script>

<style scoped>

</style>
